// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Qc8I","empty":"ModalGraph_empty__1pmx7"};